export default __webpack_public_path__ + "static/media/section4-pic1.6548bd13.png";